import { env } from '../Env.js';
import { useDialogManager } from '../ui-kit/DialogManager/useDialogManager.js';
import { adjustBase } from '../utils/adjustBase.js';
import { adjustHref } from '../utils/adjustHref.js';
import { getBasePath } from '../utils/getBasePath.js';
import { hasPrefix, isLocalURL } from '../utils/url.js';
import { handlerDecorator } from './handlerDecorator.js';
import { useRouter } from './useRouter.js';
export function useLink() {
    const basePath = getBasePath(env.SITE_URL);
    const router = useRouter();
    const { closeAll } = useDialogManager();
    return (props) => {
        const href = adjustHref(router)(props.href);
        return {
            ...props,
            href,
            'aria-label': props.text,
            onClick: handlerDecorator(handleHref({ ...props, href })),
        };
    };
    function handleHref({ href, target, onClick }) {
        return (ev) => {
            onClick && onClick(ev);
            const isRemote = !hasPrefix(href, basePath || '/');
            if (!href || isRemote || !isLocalURL(href, target)) {
                //? Default routing
                return;
            }
            closeAll();
            //? Client routing
            ev?.preventDefault();
            router.push(adjustBase(href, basePath));
        };
    }
}
//# sourceMappingURL=useLink.js.map